import CartIcon from "@/blueprint/components/NavPill/CartIcon";
import { cn } from "@/lib/utils";

type CartChipProps = {
  count: number;
  onClick: () => void;
  navControl?: string;
  className?: string;
};

const CartChip = ({ count, onClick, navControl, className }: CartChipProps) => (
  <button
    type="button"
    aria-label={
      count === 0
        ? "Cart, empty"
        : `Cart, ${count} ${count === 1 ? "item" : "items"}`
    }
    data-nav-control={navControl}
    onClick={onClick}
    className={cn(
      "flex shrink-0 items-center justify-center rounded-full text-content-primary transition-colors duration-quick hover:bg-tint-black-20 motion-reduce:transition-none",
      className,
    )}
  >
    {/* Figma ShoppingCart State=Added: the count sits in a 13px brand-blue
        circle whose corner aligns with the glyph's bottom-right. text-brand-white
        (not content-inverse) keeps it legible in dark theme, where
        content-inverse resolves to black. */}
    <span className="relative">
      <CartIcon />
      {count > 0 && (
        <span
          aria-hidden
          className="absolute bottom-0 right-0 flex size-[13px] items-center justify-center rounded-full bg-brand-blue font-ppMori text-nav-cart-count font-semibold text-brand-white"
        >
          {count}
        </span>
      )}
    </span>
  </button>
);

export default CartChip;
